/* eslint-disable */
import sysConfig from '@/configs/sys';

const matlsApiUrl = sysConfig.matlsApiUrl;

export default {
  getRoles() {
    return fetch
      .get(`${matlsApiUrl}/roles`)
      .then(res => res.json());
  }
};
